export enum FileType {
    Document = 'Document',
    Image = 'Image',
    PredefinedProfileImage = 'PredefinedProfileImage',
    TermsAndConditions = 'TermsAndConditions',
    LanguagesExcelTranslation = 'LanguagesExcelTranslation',
    UnitOfMeasureLanguagesExcelTranslation = 'UnitOfMeasureLanguagesExcelTranslation',
    ErrorCodeLanguagesExcelTranslation = 'ErrorCodeLanguagesExcelTranslation',
    LineDocument = 'LineDocument',
    LineLayout = 'LineLayout',
    AssetDocument = 'AssetDocument',
    AssetImage = 'AssetImage',
    SupportTicketAttachment = 'SupportTicketAttachment',
    MasterTranslationFile = 'MasterTranslationFile',
    AssetTypeParamFriendlyName = 'AssetTypeParamFriendlyName',
    DataContractDocument = 'DataContractDocument',
    DataContractJSON = 'DataContractJSON',
    AssetEquipmentInfoJSON = 'AssetEquipmentInfoJSON',
    Video = 'Video',
    AlertRules = 'AlertRules',
    GraphicsFile = 'GraphicsFile',
}

export const TranslationTypes = {
    STATIC_TOKEN: 'STATIC_TOKEN',
    ERROR_CODE: 'ERROR_CODE',
    TILE_TEMPLATE: 'TILE_TEMPLATE',
    UOM: 'UOM',
    PARAMETER_TRANSLATION: 'PARAMETER_TRANSLATION',
    ALERT_TOKEN: 'ALERT_TOKEN',
};
